import ARRAY from "../ARRAY";
import Cue from "./Cue";
import LOG, { log } from "../LOG";

class CueProgression
{
    public patterns             : Cue = new Cue( true );

    private segments            : Cue = new Cue( true );
    private progressions        : Cue = new Cue( true );
    private endless             : Cue = new Cue( true );

    private current             : any;
    private finishedProgression : any;
 
    public position             : number = 0;
    public length               : number = 0;

    constructor( preset:string, value:any )
    {
        if( preset == "endlessDifficulty" )     this.endlessDifficulty();
        if( preset == "endlessStatic" )         this.endlessStatic();
        if( preset == "endlessPrefill" )        this.endlessPrefill();
        if( preset == "linear" )                this.linear( value );

    }

    // Pattern blocks

    public addPattern( id:string, isRandom?:boolean )
    {
        return this.patterns.add( id, new Cue( isRandom ) );
    }

    // Segments grouping patterns together

    public addSegments( id:string, isRandom?:boolean )
    {
        return this.segments.add(  id, new Cue( isRandom ) ); 
    }

    // Sequential progression of segments

    public addProgressions(  id:string, isRandom?:boolean )
    {
        return this.progressions.add( id, new Cue( isRandom ) ); 
    }

    // Pool of randomized segments to use after progression is complete

    public addEndless(  id:string )
    {
        return this.endless.add( id, new Cue( true ) ); 
    }

    public getLength()
    {
        if( this.length ) return this.length;

        this.length = 0;

        var segmentNames = this.progressions._pool[0]._pool[0];

        for( var n in segmentNames )
        {
            var segmentPool = this.segments.data[ segmentNames[n] ]._pool[0];

            for( var i in segmentPool )
            {
                var patternPool = this.patterns.data[ segmentPool[i] ]._pool;
                for( var p in patternPool ) this.length += Array.isArray( patternPool[p] ) ? patternPool[p].length : 1;   
            }
        }

        return this.length;
    };

    public reset()
    {
        this.position = 0;
        this.patterns.reset();
        this.segments.reset();
        this.progressions.reset();
        this.endless.reset();

        this.finishedProgression = false;

        this.nextProgression();
    };
 
    private nextProgression()
    {
        if( this.finishedProgression ) return this.nextEndless();
 
        if( this.progressions.selected )
        {
            var value = this.progressions.selected.consume();

            if( !value ) 
            {
                this.finishedProgression = true;
                return this.nextEndless();
            } 

            return this.setSegment( value );
        }

        this.progressions.get();
        this.progressions.selected.get();

        this.setSegment( this.progressions.selected.consume() );
    }
 
    private nextEndless()
    {
        var value;

        if( this.endless.selected )
        {
            value = this.endless.selected.consume();
 
            if( value ) return this.setSegment( value );
        }

        this.endless.get();
        this.endless.selected.get();

        this.setSegment( this.endless.selected.consume() );
    }
 
    private setSegment( id:string )
    {
        this.segments.get( id );
        this.segments.selected.get();

        this.setPattern( this.segments.selected.consume() );
    }

    private nextSegment()
    {
        var value = this.segments.selected.consume();
        if( value != null ) return this.setPattern( value );
         
        this.nextProgression();
    }

    private setPattern( value:any )
    {
        this.patterns.get( value );
        this.current = this.patterns.selected;
        this.current.get();
    }
 
    public clear()
    {
        this.patterns.clear();
        this.segments.clear();
        this.progressions.clear();
        this.endless.clear();
    };

    // The magical get method

    public get() : any
    {
        if( !this.current ) this.reset();

        var value = this.current.consume();

        if( value !== null && value !== undefined ) 
        {
            this.position ++;
            return value;
        }
 
        this.nextSegment();

        return this.get();
    };

    public getPosition( seekPosition:number=0 )
    {
        if( !seekPosition || seekPosition < 0 ) return;
 
        this.reset();
        this.getLength();

        // Already in endless mode?

        if( seekPosition > this.length ) 
        {
          //  log("FINISHED PROGRESSION, iS ENDLESS" );
            this.finishedProgression    = true;
            this.position               = seekPosition;

            this.nextEndless();
            return this.get();
        }
 
        var value;   

        while( seekPosition > this.position ) value = this.get();

        return value;
    };
 
    /*================================


    RESETS


    ================================*/
 
    private endlessDifficulty()
    {
        this.clear();

        // PATTERNS

        this.addPattern( "easy", true );
        this.addPattern( "medium", true );
        this.addPattern( "hard", true );
        this.addPattern( "crazy", true );
 
        this.prefillSegments();
 
        return this;
    };

    private endlessStatic()
    {
        this.clear();

        // PATTERNS

        this.addPattern( "easy" );
        this.addPattern( "medium" );
        this.addPattern( "hard" );
        this.addPattern( "crazy" );

        this.prefillSegments();
 
        return this;
    };

    private endlessPrefill()
    {
        this.endlessDifficulty();

        let data = this.patterns.data;
 
        data.easy.push( [ "easy","easy","easy" ]);
        data.easy.push( [ "easy","easy","easy" ]);
        data.easy.push( [ "easy","easy" ]);
    
        data.medium.push( [ "medium","medium","medium" ]);
        data.medium.push( [ "medium","medium" ]);
        data.medium.push( [ "medium","easy","medium" ]);
        data.medium.push( [ "medium","hard","medium" ]);
    
        data.hard.push( [ "hard","hard","hard" ]);
        data.hard.push( [ "hard","hard" ]);
        data.hard.push( [ "hard","medium","hard" ]);
        data.hard.push( [ "hard","easy","hard" ]);
        data.hard.push( [ "hard","crazy","hard" ]);
    
        data.crazy.push( [ "crazy","crazy","crazy" ]);
        data.crazy.push( [ "crazy","medium","crazy" ]);
        data.crazy.push( [ "crazy","hard","crazy" ]);
        data.crazy.push( [ "crazy","easy","crazy" ]);
    };

    private linear( amount?:number )
    {
        this.clear();

        if( !amount ) return log("Pass an amount for Linear preset" );

        var name;
        var names : any = [];

        for( var n=0; n<amount; n++ )
        {
            name = "linear"+n;
 
            this.addPattern( name );
            this.addSegments( name ).push( [ name ] );

            names.push( name );
        }
        // PROGRESSION

        this.addProgressions( "progression1" ).push( names );

        // ENDGAME

        name = "endless";

        this.addPattern( name );
        this.addSegments( name ).push( [ name ] );
 
        this.addEndless( name ).push( [ name ] );
    };

    // HELPERS

    private prefillSegments()
    {
        // SEGMENTS

        var cue;

        cue = this.addSegments( "easySegments" );
        cue.push( [ "easy", "easy", "medium" ] );
 
        cue = this.addSegments( "mediumSegments" , true );
        cue.push( [ "easy", "easy",  "medium",  "medium" ] );

        cue = this.addSegments( "hardSegments", true );
        cue.push( [ "easy", "easy", "medium",  "medium", "hard", "hard", "hard" ] );

        cue = this.addSegments( "crazySegments", true );
        cue.push( [ "easy", "easy","medium", "hard", "hard", "crazy", "crazy", "crazy"  ] );

        cue = this.addSegments( "endlessSegments", true );
        cue.push( [ "easy", "medium", "medium", "hard", "hard", "hard", "crazy", "crazy", "crazy" ] );

        // PROGRESSION

        cue = this.addProgressions( "progression1" );
        cue.push( [ "easySegments", "mediumSegments", "easySegments", "hardSegments", "mediumSegments", "crazySegments" ] );

        // ENDGAME

        cue = this.addEndless( "endgame1" );
        cue.push( [ "endlessSegments" ] );
    }
 

}

export default CueProgression;